module.exports = __webpack_public_path__ + "static/media/J.460d308d.svg";